

function readFileAndConvert(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const base64Data = reader.result;
            resolve(base64Data)
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export { readFileAndConvert }